import { render, staticRenderFns } from "./StepTerms.vue?vue&type=template&id=ef261996&scoped=true&"
import script from "./StepTerms.vue?vue&type=script&lang=js&"
export * from "./StepTerms.vue?vue&type=script&lang=js&"
import style0 from "./StepTerms.vue?vue&type=style&index=0&id=ef261996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef261996",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow,VStepperContent})
